import { downloadAssignmentRecordStudents } from "../../../services/generic-services/teaching-tools/assignments"
import {
  AssignmentRecordStudentStatus,
  DownloadAssignmentRecordStudentsRequest
} from "../../../types/gqlTypes/graphql"
import { SortTypes, UseTableState } from "../components/Table"
import { FiltersState } from "../states"

export type SpecificExportCallbackArgsType = {
  filters: FiltersState
  tableState: UseTableState
  entityId?: string
}

export const assignmentRecordStudentsExportCallback = async (
  args: SpecificExportCallbackArgsType
): Promise<string | null> => {
  const { filters, tableState, entityId } = args

  if (!entityId) {
    return null
  }

  const data: DownloadAssignmentRecordStudentsRequest = {
    assignmentId: entityId,
    sortKey: tableState.sortBy || "studentId",
    reverse: tableState.order === SortTypes.desc,
    ...(!!filters.status?.length
      ? { status: [...filters.status] as AssignmentRecordStudentStatus[] }
      : {}),
    ...(!!filters.student?.length ? { studentIds: [...filters.student] } : {}),
    ...(!!filters.class?.length ? { classIds: [...filters.class] } : {})
  }

  const response = await downloadAssignmentRecordStudents(data)

  if (!response?.output) {
    return null
  }

  return response.output
}
